const endpoints = {
  auth: {
    login: '/v1/login',
    login2fa: '/v1/login-2fa',
    register: '/register',
    forgetPassword: '/forget-password',
    resetPassword: 'reset-password',
    token: 'v1/token',
  },
  getUsers: '/v1/admin/user',
  deleteUserTransHistory: '/v1/admin/users',
  getOrders: '/v1/admin/orders',
  getTranslations: '/v1/admin/translations',
  getTranslationHistory: '/v1/admin/user-translation-history',
  fileTranslations: "/v1/admin/file-translation",
  fileUpload: "v1/upload/upload_file",
  prompts: '/v1/admin/prompts',
  promptsHistory: '/v1/admin/prompts/history',
  extendPlan: '/v1/admin/extend-plan',
  emails: '/v1/admin/emails',
  emailsHistory: '/v1/admin/emails/history',

  v1: {
    translations: {
      logs: 'v1/translations/logs',
      csv: 'v1/logs/csv',
    },
    coupon: {
      list: 'v1/coupon/list',
      addCoupon: 'v1/coupon',
      couponUserList: 'v1/coupon/coupon_user_list',
      details: 'v1/coupon/detail',
      editCoupon: 'v1/coupon/edit',
    },
  },

  campaign: {
    root: 'campaigns',
    list: 'campaigns',
    activity: 'activity',
    leads: 'leads',
    status: 'toggleStatus',
    uploadContacts: 'campaign/upload_list_action',
    create: 'campaign/create',
    getSettings: 'get-campaign-setting',
    updateGeneralSettings: 'campaign-setting/general',
    updateEmailMessageSettings: 'campaign-setting/email-settings',
    updateEmailSendingCadenceSettings: 'campaign-setting/email-sending-cadence',
    updateLandingPageSettings: 'campaign-setting/landing-page',
    landingPage: 'default-landing',
  },
  partner: {
    root: 'partners',
    add: 'partner/create',
    delete: 'partners',
    listCampaign: 'partner',
    getPartnerSettings: 'partners_setting',
    updateGeneralSettings: 'partners_setting/general',
    updateEmailMessageSettings: 'partners_setting/email/default',
    updateEmailCadenceSettings: 'partners_setting/cadence/default',
    updateLandingPageSettings: 'partners_setting/page/default',
    sendTestEmail: 'send_test_email',
    updateNotificationSettings:
      'partners_setting/save_notification_email_settings',
    sendNotificationTestEmail: 'send_test_notification_email',
    getAggregateReport: 'get-partner-aggregate-report',
    getDefaultLandingPage: 'campaign-default-landing-page',
  },
  contact: {
    unsubscribe: 'contacts/unsubscribe',
    delete: 'contacts/delete',
    manualSend: 'contacts/manual_send',
    addContact: 'add-contact',
    update: 'campaigns/update-contact',
  },
  business: {
    root: 'business',
    create: '/business/create',
  },
  admin: {
    industry: {
      root: 'admin-industry',
      create: 'admin-industry/create',
    },
    campaignType: {
      root: 'admin-campaign-type',
      create: 'admin-campaign-type/create',
    },
    category: {
      root: 'admin-category',
      create: 'admin-category/create',
    },
    settings: {
      getAdminInfo: 'get-admin-info',
      root: 'admin_setting',
      updateNotification: 'admin_setting/save_notification_email_settings',
      sendTestNotificationEmail: 'send_admin_test_notification_email',
      emailMessage: 'admin_setting',
      updateGeneralSettings: 'admin_setting/general',
      updateEmailSendingCadenceSettings: 'admin_setting/cadence/default',
      sendTestEmail: 'admin_send_test_email',
      updateLandingPageSettings: 'admin_setting/page/default',
    },
  },

  manageUser: {
    list: 'sub-user-list',
    add: 'sub-user-add',
    update: 'sub-user-update',
    delete: 'sub-user-delete',
    filter: 'entity-list-by-user',
    updatePassword: 'update-password',
    updateUserPassword: 'update-user-password',
  },
  location: {
    root: 'location',
  },
  industry: {
    add: 'add-industry',
    update: 'update-industry',
    delete: 'industry',
  },
  campaignType: {
    add: 'save-campaign-type',
    update: 'update-campaign-type',
    delete: 'delete-campaign-type/id',
  },
  category: {
    add: 'save-campaign-category',
    update: 'update-campaign-category',
    delete: 'delete-campaign-category/id',
  },
};

export default endpoints;
